import Images from '@/api/images/images'

const images = new Images()

const imagesModule = {
  namespaced: true,
  state: {
    load: false,
  },
  getters: {
    load(state) {
      return state.load
    },
  },

  mutations: {
    SET_LOAD: (state, load) => {
      state.load = load
    },
  },

  actions: {

    delete({ commit }, id) {
      return new Promise((resolve, reject) => {
        images
          .delete(id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

  },
}

export default imagesModule
